import { render } from "./FieldMappingEditor.vue?vue&type=template&id=50cb62e3&scoped=true"
import script from "./FieldMappingEditor.vue?vue&type=script&lang=js"
export * from "./FieldMappingEditor.vue?vue&type=script&lang=js"

import "./FieldMappingEditor.vue?vue&type=style&index=0&id=50cb62e3&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cb62e3"]])

export default __exports__